type AuthStatus = "configuring" | "authenticated" | "unauthenticated"
type RequestState = "unknown" | "authenticated" | "signing-out" | "signed-out"

let state: RequestState = "unknown"
let epoch = 0
let sawUnauthenticatedSinceSignOut = false

export const isSignOutActive = (): boolean =>
  state === "signing-out" || state === "signed-out"

export const beginSignOut = (): void => {
  if (state === "signing-out" || state === "signed-out") return
  epoch++
  state = "signing-out"
  sawUnauthenticatedSinceSignOut = false
}

export const finishSignOut = (): void => {
  state = "signed-out"
}

export const failSignOut = (): void => {
  state = "authenticated"
}

export const updateAuthStatus = (status: AuthStatus): void => {
  if (status === "configuring") return
  if (status === "unauthenticated") {
    if (state === "authenticated") epoch++
    sawUnauthenticatedSinceSignOut = true
    if (state !== "signing-out") state = "signed-out"
    return
  }
  if (state === "signing-out") return
  if (state === "signed-out" && !sawUnauthenticatedSinceSignOut) return
  state = "authenticated"
  sawUnauthenticatedSinceSignOut = false
}

export const captureRequestEpoch = (): number => epoch

export const isRequestObsolete = (requestEpoch: number): boolean =>
  requestEpoch !== epoch || state === "signing-out" || state === "signed-out"

/** For clients without axios: abandons a request whose session has ended,
 *  with the same AbortError a cancelled `fetch` rejects with. */
export const throwIfRequestObsolete = (requestEpoch: number): void => {
  if (isRequestObsolete(requestEpoch)) {
    throw new DOMException(
      "Request belongs to a previous session",
      "AbortError",
    )
  }
}
